/**
 * @author      carlos.soto@zumper.com (Carlos J. Soto)
 * @copyright   Copyright (c) 2024, Zumper
 * @description StayLength
 */

import { useGeoLocation } from '@zcode/nr/es/shared/components/GeoLocation'
import { selectCountry, selectUrl } from '@zcode/nr/es/shared/components/GeoLocation/selectors'
import * as React from 'react'
import { useHistory } from 'react-router-dom'
import { NAV_SELECTIONS } from '../../../constants'
import { useUserMenuContext } from '../../../module/context/UserMenuContext'
import { MenuSection, UserMenuBtnRow } from '../SharedComponents'

export const StayLength = () => {
  const history = useHistory()
  const [getGeoLocation, isSafeForClientOnly] = useGeoLocation()
  const geoLocation = isSafeForClientOnly ? getGeoLocation() : {}
  const url = selectUrl(geoLocation)
  const country = selectCountry(geoLocation)?.toLocaleLowerCase() ?? ''
  const isUSOrCan = country === 'us' || country === 'ca'

  const { handleStayLengthChange, isCurrentSearchView } = useUserMenuContext()
  const onClickHandler = (term: NAV_SELECTIONS) => {
    if (!isCurrentSearchView) {
      history.push({
        pathname: `/apartments-for-rent/${url && isUSOrCan ? url : 'san-francisco-ca'}`,
        search: term === NAV_SELECTIONS.SHORT_TERM ? '?lease-term=short' : '',
      })
      return
    }

    if (handleStayLengthChange) {
      handleStayLengthChange(term)
    }
  }
  return (
    <MenuSection>
      <UserMenuBtnRow
        closeOnSelect
        withIcon={false}
        onClick={() => onClickHandler(NAV_SELECTIONS.LONG_TERM)}
      >
        Long-term rentals
      </UserMenuBtnRow>
      <UserMenuBtnRow
        closeOnSelect
        withIcon={false}
        onClick={() => onClickHandler(NAV_SELECTIONS.SHORT_TERM)}
      >
        Short-term rentals
      </UserMenuBtnRow>
    </MenuSection>
  )
}
